<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <!-- Welcome Section -->
            <v-flex xs12>
                <v-card class="mb-0 pa-3">
                    <v-layout row class="py-3" justify-start>
                        <v-img
                            :src="logo"
                            style="max-width: 70px;"
                            class="mx-3"
                        />
                        <div>
                            <div class="display-1 my-0 pt-1 ml-1">
                                UTA User Portal Dashboard
                            </div>
                            <div
                                class="body-1"
                                style="padding-top: 3px; margin-left: 6px;"
                            >
                                User: {{ user }}
                            </div>
                        </div>

                        <v-spacer></v-spacer>
                    </v-layout>
                    <!-- <v-card-text class="mb-0 pb-2 pt-0">
                        <p>
                            Here’s a quick overview of your tickets and shared
                            files.
                        </p>
                    </v-card-text> -->
                </v-card>
            </v-flex>

            <!-- Tickets Section -->
            <v-flex xs6>
                <v-card class="mb-0 pb-3">
                    <v-card-title class="pb-1 pt-2" primary-title>
                        <v-icon color="success" class="mr-2"
                            >mdi-help-circle-outline</v-icon
                        >
                        <h4 class="card-title font-weight-medium">
                            Help Desk
                        </h4>
                    </v-card-title>
                    <div style="border: #5cb860 1px solid" class="mx-3">
                        <div
                            class="white--text px-2 py-1 subheading-2"
                            style="background-color: #5cb860;"
                        >
                            Support Tickets
                        </div>

                        <v-card-text class="mx-3 mt-2">
                            <v-layout row class="mb-2 pt-1">
                                <div class="font-weight-medium mr-2">
                                    Open Tickets:
                                </div>
                                <v-progress-linear
                                    :indeterminate="true"
                                    class="ml-1 dashboard-loading"
                                    height="2"
                                    v-if="openTicketsCountLoading"
                                ></v-progress-linear>
                                <div v-if="!openTicketsCountLoading">
                                    {{ openTicketsCount }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-0">
                                <div class="font-weight-medium mr-2">
                                    Closed Tickets:
                                </div>
                                <v-progress-linear
                                    :indeterminate="true"
                                    class="ml-1 dashboard-loading"
                                    height="2"
                                    v-if="closedTicketsCountLoading"
                                ></v-progress-linear>
                                <div v-if="!closedTicketsCountLoading">
                                    {{ closedTicketsCount }}
                                </div>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="pb-3">
                            <v-btn
                                color="success"
                                small
                                :to="{ name: 'HelpDeskRequests' }"
                            >
                                View Tickets
                            </v-btn>
                            <v-btn
                                color="success"
                                small
                                :to="{
                                    name: 'HelpDeskRequests',
                                    query: {
                                        openNewTicket: true,
                                    },
                                }"
                            >
                                New Ticket
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-card>
            </v-flex>

            <!-- Shared Files Section -->
            <v-flex xs6>
                <v-card class="mb-0">
                    <v-card-title class="pb-1 pt-2" primary-title>
                        <v-icon class="mr-2" color="success"
                            >mdi-file-move</v-icon
                        >
                        <h4 class="card-title font-weight-medium">
                            Shared Files
                        </h4>
                    </v-card-title>
                    <v-card-text class="mx-3">
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium mr-2">
                                Files Shared With You:
                            </div>
                            <v-progress-linear
                                :indeterminate="true"
                                class="ml-1 dashboard-loading"
                                height="2"
                                v-if="sharedWithYouCountLoading"
                            ></v-progress-linear>
                            <div v-if="!sharedWithYouCountLoading">
                                <a href="/shared-files">{{
                                    sharedWithYouCount
                                }}</a>
                            </div>
                        </v-layout>
                        <v-layout row class="mb-2">
                            <div class="font-weight-medium mr-2">
                                Files You Shared:
                            </div>
                            <v-progress-linear
                                :indeterminate="true"
                                class="ml-1 dashboard-loading"
                                height="2"
                                v-if="sharedByYouCountLoading"
                            ></v-progress-linear>
                            <div v-if="!sharedByYouCountLoading">
                                <a href="/shared-files">{{
                                    sharedByYouCount
                                }}</a>
                            </div>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions class="pb-3">
                        <v-btn
                            color="success"
                            small
                            :to="{
                                name: 'SharedFiles',
                                query: {
                                    shareNewFile: true,
                                },
                            }"
                            class="mr-2"
                        >
                            Share New File
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>

            <!-- Parent Info Section -->
            <v-flex xs6>
                <v-card class="mb-4">
                    <v-card-title class="pb-1 pt-2" primary-title>
                        <v-icon class="mr-2" color="success"
                            >mdi-book-open-page-variant</v-icon
                        >
                        <h4 class="card-title font-weight-medium">
                            Parent Info
                        </h4>
                    </v-card-title>
                    <v-card-text class="pt-2 mx-3 pl-0">
                        <div
                            v-for="publication in parentInfoPublications"
                            :key="publication.id"
                            class="mb-2"
                        >
                            <v-btn
                                style="border: #f62017 1px solid; color: #f62017;"
                                class="my-0"
                                small
                                depressed
                                @click="openPublication(publication)"
                            >
                                <v-icon left class="mr-2">mdi-file-pdf</v-icon>
                                {{ publication.description }}
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "Dashboard",
    data() {
        return {
            logo: "https://utaw.blob.core.windows.net/images/logo+uta11.png",

            openTicketsCount: 0,
            closedTicketsCount: 0,
            sharedWithYouCount: 0,
            sharedByYouCount: 0,

            openTicketsCountLoading: true,
            closedTicketsCountLoading: true,
            sharedWithYouCountLoading: true,
            sharedByYouCountLoading: true,
            user: "",

            parentInfoPublications: [],
        };
    },
    created() {
        this.user = this.$store.state.authentication.user;

        this.loadDashboardInfo();
    },
    methods: {
        async loadDashboardInfo() {
            try {
                const info = await this.$http.get(
                    "api/adminPortal/getDashboardInfo?user=" +
                        this.$store.state.authentication.user,
                );

                this.openTicketsCount = info.openRequests;
                this.closedTicketsCount = info.closedRequests;
                this.sharedWithYouCount = info.filesSharedWithUser;
                this.sharedByYouCount = info.sharedFiles;
                this.parentInfoPublications = info.parentInfoPublications;

                this.openTicketsCountLoading = false;
                this.closedTicketsCountLoading = false;
                this.sharedWithYouCountLoading = false;
                this.sharedByYouCountLoading = false;
            } catch (e) {
                this.openTicketsCountLoading = false;
                this.closedTicketsCountLoading = false;
                this.sharedWithYouCountLoading = false;
                this.sharedByYouCountLoading = false;
            }
        },
        openPublication(publication) {
            window.open(publication.fileURL);
        },
    },
};
</script>

<style>
.dashboard-loading {
    max-width: 100px;
    margin-bottom: 0px;
    margin-top: 12px;
}
</style>
